import {Service} from '@/content/pages/services/index';

export default {
  icon: require('@/assets/icons/services/pricing_icon.png'),
  title: 'Casino SEO Outreach',
  bullet: 'One of the world leaders in effective SEO Outreach for igaming.',
  url: '/casino-seo',
  meta: {
    title: '',
    // TODO
  },
} as Service;
